import type { CSSProperties } from 'react';

type CountBadgeWeight = 'medium' | 'semibold';

type CountBadgeProps = {
  count: number;
  className?: string;
  style?: CSSProperties;
  weight?: CountBadgeWeight;
  tabularNums?: boolean;
};

export function CountBadge({
  count,
  className = 'ml-1.5',
  style,
  weight = 'semibold',
  tabularNums = true,
}: Readonly<CountBadgeProps>) {
  const weightClassName = weight === 'medium' ? 'font-medium' : 'font-semibold';
  const tabularNumsClassName = tabularNums ? 'tabular-nums' : '';

  return (
    <span
      className={`${className} rounded-full bg-neut-200 px-2 py-0.5 text-xs ${weightClassName} text-neut-700 ${tabularNumsClassName}`}
      style={style}
    >
      {count}
    </span>
  );
}
